import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SetUserName } from '@app/core/store/app.actions';
import { CookieData, CookieSessionData, TokensResponse, UserData } from '@app/_models/users/user';
import { ApiService } from '@app/_services/api.service';
import { environment } from '@env/environment.local';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserHelper {
    constructor(private store: Store, private apiService: ApiService, private activeRoute: ActivatedRoute) {}

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json, text/javascript, */*; q=0.01',
        }),
        withCredentials: true,
    };

    removeUserData(): boolean {
        this.getDataScope().removeItem('userData');
        this.removePagesLang();

        return true;
    }

    storageUserData(data: UserData) {
        this.store.dispatch(new SetUserName(data.userName));
        const rememberMe: boolean = data?.rememberMe;
        const storage = rememberMe ? localStorage : sessionStorage;
        storage.setItem(
            'userData',
            JSON.stringify({
                token: data?.token,
                rememberMe: rememberMe,
                userName: data?.userName,
            })
        );
    }

    getUserData(): UserData {
        const userDataInLocalStorage: UserData | null = JSON.parse(localStorage.getItem('userData'));
        const userDataInSessionStorage: UserData | null = JSON.parse(sessionStorage.getItem('userData'));
        return userDataInLocalStorage != null ? userDataInLocalStorage : userDataInSessionStorage;
    }

    getTokenFromParams(): string | null {
        const url_string = window.location.href;
        const url = new URL(url_string);
        return url.searchParams.get('token');
    }

    getDataScope(): any {
        return this.getRememberMe() ? localStorage : sessionStorage;
    }

    removePersistFlag(): void {
        localStorage.removeItem('persistSession');
    }

    removeMarketId(): void {
        sessionStorage.removeItem('marketId');
    }

    removePagesLang(): void {
        localStorage.removeItem('pagesLang');
    }

    removeEsMarcaBlanca(): void {
        localStorage.removeItem('marcaBlanca');
    }

    removeEsPWA(): void {
        localStorage.removeItem('esPWA');
    }

    logout(clearSection?: boolean): void {
        const destroyedSession = true;
        const url = window.location.hostname;
        const host = window.location.host;
        const esMarcaBlanca = url.includes(environment.marca_blanca.domain);
        const esPWA = localStorage.getItem('esPWA') === 'true';

        const esMarcaBlancaStorage = localStorage.getItem('marcaBlanca') === 'true';

        let redirectUrl = '';

        var section = '';

        if (!clearSection) {
            if (localStorage.getItem('App.lastVisit')) {
                var sUrl = localStorage.getItem('App.lastVisit').split('"')[1];
                section = '&section=' + sUrl;
            } else {
                const sectionSplit = window.location.href.split('admin')[1];
                if (sectionSplit?.length) {
                    section = `&section=/admin${sectionSplit}`;
                }
            }
        }


        // Hasta 09/10/24
        // if (esMarcaBlanca) {
        //     redirectUrl = `${environment.marca_blanca.logoutPath}/login?destroyedSession=${destroyedSession}&host=${host}`;
        // } else if (environment.name !== 'PROD') {
        //     redirectUrl = `${environment.authPath}/login?destroyedSession=${destroyedSession}&host=${host}`;
        // } else {
        //     redirectUrl = 'https://micuenta.donweb.com/es-ar/servicios/sitio-simple';
        // }

        if (environment.name === 'PROD') {
            // Es Prod y Es PWA y Es MB >> https://auth.easybuild.website/login
            // Es Prod y NO Es PWA y Es MB >> https://auth.easybuild.website/login
            // Es Prod y Es PWA y Es SS >> https://auth.sitiosimple.com/login
            // Es Prod y NO Es PWA y Es SS >> https://micuenta.donweb.com/es-ar/servicios/sitio-simple

            if (esMarcaBlanca && esPWA) {
                console.log('Es prod - esmarcaBlanca y esPWA? ', esMarcaBlanca && esPWA);
                redirectUrl = `https://auth.easybuild.website/login`;
            }

            if (esMarcaBlanca && !esPWA) {
                console.log('Es prod - esmarcaBlanca y !esPWA? ', esMarcaBlanca && !esPWA);
                redirectUrl = `https://auth.easybuild.website/login`;
            }

            if (!esMarcaBlanca && esPWA) {
                console.log('Es prod - !esmarcaBlanca y esPWA? ', !esMarcaBlanca && esPWA);
                redirectUrl = `https://auth.sitiosimple.com/login`;
            }

            if (!esMarcaBlanca && !esPWA) {
                console.log('Es prod - !esmarcaBlanca y !esPWA? ', !esMarcaBlanca && !esPWA);
                redirectUrl = `https://micuenta.donweb.com/es-ar/servicios/sitio-simple`;
            }
        } else {
            // Es Incu y Es PWA y Es SS >> https://auth.incubator.newss.beer/login
            // Es Incu y Es PWA y Es MB >> http://auth.incubator.erpabruaegne.site/login
            // Es Incu y NO Es PWA y Es SS >> https://auth.incubator.newss.beer/login
            // Es Incu y NO Es PWA y Es MB >> http://auth.incubator.erpabruaegne.site/login

            // Configuracion para NO PROD
            if (!esMarcaBlanca && esPWA) {
                redirectUrl = `${environment.authPath}/login?destroyedSession=${destroyedSession}&host=${host}${section}`;
            }

            if (esMarcaBlanca && esPWA) {
                redirectUrl = `${environment.marca_blanca.logoutPath}/login?destroyedSession=${destroyedSession}&host=${host}${section}`;
            }

            if (!esMarcaBlanca && !esPWA) {
                redirectUrl = `${environment.authPath}/login?destroyedSession=${destroyedSession}&host=${host}${section}`;
            }

            if (esMarcaBlanca && !esPWA) {
                redirectUrl = `${environment.marca_blanca.logoutPath}/login?destroyedSession=${destroyedSession}&host=${host}${section}`;
            }
        }

        // this.showLogoutData(url, esMarcaBlanca, redirectUrl, esPWA, esMarcaBlancaStorage);

        this.removeUserData();
        this.removePersistFlag();
        this.removeMarketId();
        this.removeEsMarcaBlanca();
        this.removeEsPWA();
        window.location.replace(redirectUrl);
    }

    private showLogoutData(
        hostName: string,
        esMarcaBlanca: boolean,
        urlLogout: string,
        esPWA: boolean,
        esMarcaBlancaStorage: boolean
    ): void {
        console.group('%cLogout', 'color: white; font-weight: bold;');
        console.log(`%cEnvironmentName: ${environment.name}`, 'color: orange; font-weight: bold;');
        console.log(`%cHostName: ${hostName}`, 'color: orange; font-weight: bold;');
        console.log(`%cDominioMarcaBlanca: ${environment.marca_blanca.domain}`, 'color: white; font-weight: bold;');
        console.log(
            `%cEsMarcaBlanca?: ${esMarcaBlanca}`,
            `color: ${esMarcaBlanca ? 'green' : 'red'}; font-weight: bold;`
        );
        console.log(
            `%cEsMarcaBlancaStorage?: ${esMarcaBlancaStorage}`,
            `color: ${esMarcaBlancaStorage ? 'green' : 'red'}; font-weight: bold;`
        );
        console.log(`%cEsPWA?: ${esPWA}`, `color: ${esPWA ? 'green' : 'red'}; font-weight: bold;`);
        console.log(`%cUrlLogout: ${urlLogout}`, 'color: white; font-weight: bold;');
        console.groupEnd();
    }

    refreshToken(refreshToken: string): Observable<any> {
        const userData: UserData = this.getUserData();
        const tokens: TokensResponse = {
            token: userData.token,
            refreshToken: refreshToken,
        };
        return this.apiService.postFz(`/api/refreshtoken`, tokens);
    }
    createJWTCookie(data) {
        return this.apiService.postFz(`/api/cookie`, data, this.httpOptions).subscribe();
    }

    createJWTSessionCookie(data) {
        return this.apiService.postFz(`/api/sessioncookie`, data, this.httpOptions).subscribe();
    }

    getJWTCookie() {
        return this.apiService.getFz(`/api/cookie`, this.httpOptions);
    }

    getJWTSessionCookie() {
        return this.apiService.getFz(`/api/cookiesession`, this.httpOptions);
    }

    getJWTSessionCookieTest() {
        this.apiService.getFz(`/api/cookiesession`, this.httpOptions).subscribe();
    }

    setJWTCookie(cookieData: CookieData) {
        this.apiService
            .getFz(`/api/setcookie?value=${cookieData.value}&rememberMe=${cookieData.rememberMe}`, this.httpOptions)
            .subscribe();
    }

    setJWTSessionCookie(cookieData: CookieSessionData) {
        this.apiService
            .getFz(`/api/setauthcookie?value=${cookieData.token}&rememberMe=${cookieData.rememberMe}`, this.httpOptions)
            .subscribe();
    }

    deleteJWTCookie() {
        return this.apiService.get(`/api/deletecookie`, this.httpOptions);
    }

    checkToken() {
        return this.apiService.get(`/api/v1/back/checktoken`, this.httpOptions);
    }

    getUserName = (): string => this.getUserData()?.userName || '';

    setUserName = (userName: string) => {
        const userData: UserData = this.getUserData();
        userData.userName = userName;
        this.storageUserData(userData);
        this.store.dispatch(new SetUserName(userName));
    };

    getRememberMe = (): boolean => this.getUserData()?.rememberMe || false;
}
